// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__LZgle","label":"index_label__GJgPc","label-text":"index_label-text__a89S+","value":"index_value__pQeyQ"};